/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * PNRタイプ
 */
export interface GetOrderResponseDataOrderType {
  /**
   * 社員用PNR区分<br/> フリーテキストがSTFであるOSIが存在するか、PTCがASBである搭乗者が存在する場合にtrue
   */
  isStaffBooking?: boolean;
  /**
   * 特典PNR区分<br/> SSR FQTRが存在し、かつPNR作成オフィスIDの4-5桁目がNHである場合にtrue
   */
  isAwardBooking?: boolean;
  /**
   * PNRチャネル区分<br/> nh：PNRオーナーオフィスIDの4-6桁目を抜き出した文字列直営がHD0である<br/> nh0：直営PNR(PNRオーナーオフィスIDの4-6桁目がNH0である)<br/> ndc：NDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在する)<br/> nh3：国内代理店作成PNR(PNRオーナーオフィスIDの4-6桁目がNH3である)<br/> gds：GDS PNR(上記以外の場合)
   */
  channelType: GetOrderResponseDataOrderType.ChannelTypeEnum;
  /**
   * PNRチャネル詳細区分<br/> asw：ASW作成PNR(PNRオーナーオフィスIDがオフィスマスタに存在する)<br/> callCenter：コールセンター作成PNR(PNRオーナーオフィスIDがオフィスマスタに存在せず、かつ4-6桁目がNH0である)<br/> merchantAnaNdc：マーチャントがANAのNDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在し、かつマーチャント識別が1)<br/> merchantNotAnaNdc：マーチャントがANA以外のNDC PNR(PNRオーナーオフィスIDがNDCオフィスマスタに存在し、かつマーチャント識別が2)<br/> ※PNRチャネル区分がnhまたはndcである場合にのみ設定される
   */
  channelDetail?: GetOrderResponseDataOrderType.ChannelDetailEnum;
  /**
   * グループPNR区分<br/> DxAPIよりグループPNR識別が返却されている場合にtrue
   */
  isGroupBooking?: boolean;
  /**
   * prebookPNRであるか<br/> 以下のすべての条件に該当する場合にtrue、いずれか該当しない場合はfalse<br/> 1.PNRオーナーオフィスIDがASWDB(マスタ)のオフィスマスタに存在する<br/> 2.コードがTIMEであるSSR(Keep My FareのSSR)が存在しない<br/> 3.特典の減算を含む航空券のFPエレメントについて、以下を全て満たすものが存在しない<br/> 3-1.FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWBCASHまたはWCCASHである<br/> 3-2 払込期限(※)が存在し、現在時刻を過ぎていない<br/> ※ FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの4番目に払込期限がyyyyMMddHHmmss形式で返却される。<br/> 4.DxAPIから有効期限、支払期限、発券期限の3つ全てが返却されている<br/> 5.RMエレメントに予約のみで完了を示す所定の文字列(設定ファイルにて管理)が存在しない<br/> 6.特典PNRではない<br/> ※概要に記載の通り、リクエストにカートIDが指定された場合のみ当項目はtrueとなる可能性がある。<br/>
   */
  isPrebooking?: boolean;
  /**
   * 海外ツアーPNR区分<br/> PNRオーナーオフィスコードが、設定ファイルに定義される海外ツアーオフィスコードパターンと前方一致する場合にtrue
   */
  isInternationalTourBooking?: boolean;
  /**
   * INFINI PNR区分<br/> PNRオーナーオフィスコードが、設定ファイルに定義されるINFINI PNRオフィスコードリストに含まれる場合にtrue
   */
  isInfiniBooking?: boolean;
  /**
   * INFINIツアーPNR区分<br/> INFINI PNR区分がtrueであり、かつフリーテキストが\"HANT\"で始まるOSIエレメントが存在する場合true
   */
  isInfiniTourBooking?: boolean;
  /**
   * ANA BizPNR区分<br/> SK BIZJ、SK BIZCのいずれかが登録されている場合にtrue
   */
  isBusinessTripBooking?: boolean;
  /**
   * ANA Biz専用運賃区分<br/> 以下の全ての条件に合致する場合、true<br/> 1.特典PNR区分がfalse<br/> 2.旅程区分が日本国内単独旅程(domestic)である<br/> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.全Fare Basisの7桁目がANA Biz専用運賃のFare ID(設定ファイルに定義)と合致する
   */
  isBusinessTripFare?: boolean;
  /**
   * ANA Biz適用不可運賃区分<br/> 以下の全ての条件に合致する場合、true<br/> 1.特典PNR区分がfalse<br/> 2.旅程区分が日本国内単独旅程(domestic)である<br/> 3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/> 4.全Fare Basisの7桁目がANA Biz適用不可運賃のFare ID(設定ファイルに定義)と合致する
   */
  isBusinessTripNotAppliableFare?: boolean;
  /**
   * 企業ID<br/> ANA BizPNR区分がtrueの場合に、SK BIZJ、SK BIZCのフリーテキスト部に登録されている企業IDを返却する<br/> ※フォーマットは「企業ID + \"/\" + 組織ID」の想定<br/> ※購入・発券状態が発券済みである場合にのみ返却する
   */
  companyId?: string;
  /**
   * 組織ID<br/> ANA BizPNR区分がtrueの場合に、SK BIZJ、SK BIZCのフリーテキスト部に登録されている組織IDを返却する<br/> ※フォーマットについては上記「企業ID」を参照<br/> ※購入・発券状態が発券済みである場合にのみ返却する
   */
  organizationId?: string;
  /**
   * 大人が同行しない小児単独予約であるか<br/> 搭乗者種別がCHD以外である搭乗者が存在せず、かつSSR UMNRが登録されている場合にtrue
   */
  isSoloChildBooking?: boolean;
}
export namespace GetOrderResponseDataOrderType {
  export type ChannelTypeEnum = 'nh' | 'nh0' | 'ndc' | 'nh3' | 'gds';
  export const ChannelTypeEnum = {
    Nh: 'nh' as ChannelTypeEnum,
    Ndc: 'ndc' as ChannelTypeEnum,
    Nh0: 'nh0' as ChannelTypeEnum,
    Nh3: 'nh3' as ChannelTypeEnum,
    Gds: 'gds' as ChannelTypeEnum,
  };
  export type ChannelDetailEnum = 'asw' | 'callCenter' | 'merchantAnaNdc' | 'merchantNotAnaNdc';
  export const ChannelDetailEnum = {
    Asw: 'asw' as ChannelDetailEnum,
    CallCenter: 'callCenter' as ChannelDetailEnum,
    MerchantAnaNdc: 'merchantAnaNdc' as ChannelDetailEnum,
    MerchantNotAnaNdc: 'merchantNotAnaNdc' as ChannelDetailEnum,
  };
}
